export const DEFAULT_EDGE_REMOVAL_TARGET_PREFIX = "default-edge-removal";
export const DEFAULT_EDGE_PRODUCTS = [
    {
        itemKind: "edge_compute",
        productPartNo: "AUTO-EDGE-GATEWAY",
        role: "Edge gateway",
        supplySource: "in_house"
    }
];
export const defaultEdgeProductForPartNo = (productPartNo) => {
    const normalizedPartNo = productPartNo?.toUpperCase();
    return DEFAULT_EDGE_PRODUCTS.find((product) => product.productPartNo === normalizedPartNo);
};
export const isDefaultEdgeProductPartNo = (productPartNo) => defaultEdgeProductForPartNo(productPartNo) !== undefined;
export const isDefaultEdgeRemovalSelector = (selector) => {
    const product = defaultEdgeProductForPartNo(selector.productPartNo);
    return product !== undefined && selector.itemKind === product.itemKind;
};
export const defaultEdgeRemovalTargetRef = (productPartNo) => {
    const normalizedPartNo = defaultEdgeProductForPartNo(productPartNo)?.productPartNo ??
        productPartNo.toUpperCase();
    return `${DEFAULT_EDGE_REMOVAL_TARGET_PREFIX}:${normalizedPartNo}`;
};
export const defaultEdgeRemovalPartNoFromTargetRef = (targetRef) => {
    const targetPrefix = `${DEFAULT_EDGE_REMOVAL_TARGET_PREFIX}:`;
    if (!targetRef?.startsWith(targetPrefix)) {
        return null;
    }
    return (defaultEdgeProductForPartNo(targetRef.slice(targetPrefix.length))?.productPartNo ??
        null);
};
export const solutionHasExplicitEdgeOutput = (solution) => (solution.edgeFeatures ?? []).length > 0 ||
    solution.infrastructure.some((item) => [
        item.itemKind ?? "",
        item.capabilityRole ?? "",
        item.placeholderName ?? "",
        item.productPartNo ?? ""
    ]
        .join(" ")
        .toLowerCase()
        .includes("edge"));
export const shouldInjectDefaultEdgeRows = (solution) => !solutionHasExplicitEdgeOutput(solution);
//# sourceMappingURL=defaultEdge.js.map